import {
  Form,
  InputProps,
  AutoCompleteV2OnSuggestionSelected,
} from '@doveit/bricks';
import React from 'react';
import { searchPhotographers } from '../../../providers/api/shooting/photographerProvider';
import { PhotographerSearchResult } from '../../../providers/api/dtos';

export interface PhotographerAutoCompleteProps extends InputProps {
  initialPhotographer?: PhotographerSearchResult,
  onSuggestionSelected?: AutoCompleteV2OnSuggestionSelected<PhotographerSearchResult>,
}

const PhotographerAutoComplete: React.FC<PhotographerAutoCompleteProps> = ({
  name: autocompleteName = 'photographer',
  label = 'Nome fotografo',
  size,
  initialPhotographer,
  onSuggestionSelected,
}) => {
  const fetchSuggestions = React.useCallback(async (query: string) => searchPhotographers(query.trim()), []);

  const printSuggestion = React.useCallback((suggestion: PhotographerSearchResult) => suggestion.fullName || suggestion.name, []);

  return (
    <Form.AutoCompleteV2
      name={autocompleteName}
      label={label}
      size={size}
      aria-label="Campo per specificare il nome di un fotografo"
      placeholder="Inizia a digitare"
      printSuggestion={printSuggestion}
      suggestions={fetchSuggestions}
      onSuggestionSelected={onSuggestionSelected}
      value={initialPhotographer}
    />
  );
};

export default PhotographerAutoComplete;
